// ParentComponent.js (Example)
import React, { useState, useEffect } from 'react';

// A key to use for session storage
const POPUP_SEEN_KEY = 'elliePopupSeen';

// function ParentComponent() {
//     // State to control the *actual* rendering of the popup
//     const [showPopup, setShowPopup] = useState(false);

//     useEffect(() => {
//         // Check if the popup has already been shown in this session
//         const hasSeenPopup = sessionStorage.getItem(POPUP_SEEN_KEY);

//         // If it hasn't been seen yet in this session...
//         if (!hasSeenPopup) {
//             // ...set the state to display it.
//             setShowPopup(true);
//             // OPTION 1: Mark as seen immediately when it's decided to show it.
//             // sessionStorage.setItem(POPUP_SEEN_KEY, 'true');
//         }
//         // No 'else' needed, the default state is false, so it won't show if already seen.

//     }, []); // The empty dependency array ensures this effect runs only *once* when the parent component mounts

//     const handleClosePopup = () => {
//         setShowPopup(false);
//         // OPTION 2 (Recommended): Mark as seen *only when the user explicitly closes it*.
//         // This ensures they saw it. If they reload before closing, it might reappear,
//         // which could be acceptable or not depending on exact requirements.
//         // Choose this OR Option 1 above.
//         sessionStorage.setItem(POPUP_SEEN_KEY, 'true');
//     };

//     return (
//         <div>
//             {/* ... other parent component content ... */}

//             <ElliePopUp
//                 isDisplayed={showPopup}
//                 onClose={handleClosePopup}
//             />

//             {/* ... other parent component content ... */}
//         </div>
//     );
// }



const ElliePopUp = ({ isDisplayed, onClose }) => {
    const [visible, setVisible] = useState(isDisplayed);
    const [hasHovered, setHasHovered] = useState(false);
    const hasSeenPopup = sessionStorage.getItem(POPUP_SEEN_KEY);

    useEffect(() => {
        if (isDisplayed && !hasSeenPopup) {
            setVisible(true);
            sessionStorage.setItem(POPUP_SEEN_KEY, 'true'); // Mark as seen when displayed
        } else {
            setTimeout(() => setVisible(false), 500); // Allow slide-out animation
        }
    }, [isDisplayed]);

    if (!visible) return null;

    const handleFirstHover = () => {
        if (!hasHovered) setHasHovered(true);
    };

    return (
        <div
            className={`fixed bottom-0 right-0 z-50 w-auto h-auto p-6 pointer-events-none transition-transform duration-500 ${isDisplayed ? 'animate-slideInBottomRight' : 'animate-slideOutDown'
                }`}
        >
            <div className="relative pointer-events-auto flex flex-col items-center space-y-4 group">

                {/* Message Box */}
                <div
                    onMouseEnter={handleFirstHover}
                    className="bg-blue-600 text-white px-6 py-4 rounded-md shadow-lg text-base font-medium text-center transition-all duration-500 ease-in-out"
                >

                    <div className='flex justify-between items-center'>
                        Hi! Welcome to Site Service Cloud
                        <button
                            onClick={onClose}
                            className="text-white text-lg bg-black/40 hover:bg-black/70 px-2 py-1 rounded-full  ml-2"
                        >
                            ✕
                        </button>
                    </div>
                    {hasHovered && (
                        <div className="text-md mt-2 animate-fadeIn">I am here to assist you.</div>
                    )}
                    {/* Close Button */}

                </div>

                {/* Ellie Image */}
                <img
                    src="assets/ellie.png"
                    alt="Ellie"
                    onMouseEnter={handleFirstHover}
                    className="max-w-[300px] drop-shadow-2xl transition-transform duration-300 ease-in-out hover:scale-105"
                    style={{ objectFit: 'contain' }}
                />


            </div>
        </div>
    );
};



export default ElliePopUp;


